require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};